// let files = {
//   cover: '12-12-12/2233333333.png', // 选填
//   duration: 9, // 选填
//   size: 12345, // 选填
//   name: 'works.mp4', // 必填
//   url: '12-12-12/2233333333.mp4', // url,file字段二选一
//   file: Blob || File // url,file字段二选一
// };
const state = {
  files: [],
  sizes: {},
  pipeFiles: []
};

const getters = {
  getFiles: (state) => state.files,
  getPipeFiles: (state) => state.pipeFiles,
  getSizes: (state) => state.sizes
};

const mutations = {
  setFiles(state, files) {
    console.log('turbo: setFiles -> files', files);
    state.files = files;
  },
  clearFiles(state) {
    state.files = [];
  },
  addFile(state, file) {
    state.files.push(file);
  },
  deleteFile(state, file) {
    let index = state.files.indexOf(file);
    if (index > -1) {
      state.files.splice(index, 1);
    }
  },
  addSizeItem(state, { key, value }) {
    state.sizes[key] = value;
  },
  setPipeFiles(state, files) {
    state.pipeFiles = files;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations
};
